var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAusSuperSymbolTonalWhite = function SvgAusSuperSymbolTonalWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 200 136",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M173.535 22.63c3.054-.272 4.766 3.415 2.569 5.537l-87.131 83.976c-2.602 2.506-6.786-.415-5.251-3.671l22.764-48.227c6.35-14.986 6.511-28.2-4.362-31.44l71.411-6.175z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.882 35.397c-3.716.319-4.072 5.538-.453 6.367l81.057 18.48c6.349-14.985 6.511-28.23-4.362-31.438l-76.242 6.59z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aus-super-symbol-tonal-white_svg__paint0_linear_2255_22113",
    x1: 43.383,
    x2: 110.858,
    y1: 60.462,
    y2: 21.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    stopColor: "currentColor",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAusSuperSymbolTonalWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aus-super-symbol-tonal-white.fff35e0c9c5ef2273baec3c3cecc792e.svg";